import { Lang } from '@/i18n/config';
import { replacePlaceholdersInObject } from "@/utils/stringReplacer";
import { dynamicValues } from '@/utils/dynamicValues';

import homeDe from './modules/home';
import aboutDe from './modules/about';
import workDe from './modules/work';
import contactDe from './modules/contact';
import cvDe from './modules/cv';
import { imprintData as imprintDe } from './modules/imprint';
import { privacyData as privacyDe } from './modules/privacy';
import uiDe from './modules/ui';
import blogDe from './modules/blog';

import homeEn from './en/modules/home';
import aboutEn from './en/modules/about';
import workEn from './en/modules/work';
import contactEn from './en/modules/contact';
import cvEn from './en/modules/cv';
import { imprintData as imprintEn } from './en/modules/imprint';
import { privacyData as privacyEn } from './en/modules/privacy';
import uiEn from './en/modules/ui';
import blogEn from './en/modules/blog';

export * from './types';

const trees = {
  de: {
    dynamicValues,
    home: homeDe,
    about: aboutDe,
    work: workDe,
    contact: contactDe,
    cv: cvDe,
    blog: blogDe,
    imprint: imprintDe,
    privacy: privacyDe,
    ui: uiDe
  },
  en: {
    dynamicValues,
    home: homeEn,
    about: aboutEn,
    work: workEn,
    contact: contactEn,
    cv: cvEn,
    blog: blogEn,
    imprint: imprintEn,
    privacy: privacyEn,
    ui: uiEn
  }
} as const;

export type AppData = ReturnType<typeof buildData>;

function buildData(lang: Lang) {
  return replacePlaceholdersInObject(trees[lang]);
}

const cache: Partial<Record<Lang, ReturnType<typeof buildData>>> = {};

/** Sprachabhängiger Datenbaum (Platzhalter bereits ersetzt, gecacht). */
export function getData(lang: Lang) {
  return (cache[lang] ??= buildData(lang));
}

// Übergangs-Export für sprachunabhängige Konsumenten (Schemas, Sitemap):
// entspricht der deutschen Fassung.
const data = getData('de');
export default data;
